import React from 'react';
import { MessageCircle } from 'lucide-react';
import { CommentCard } from './CommentCard';
const comments = [{
  name: 'Rachel M.',
  initial: 'RM',
  timestamp: '2 days ago',
  text: "This article convinced me to try it. Just got mine yesterday and I'm genuinely surprised the resistance is real and it does slow your breath down automatically. Skeptic officially converted.",
  likes: 127
}, {
  name: 'Tom H.',
  initial: 'TH',
  timestamp: '3 days ago',
  text: "I bought the Amazon knockoff first too! Same experience — completely useless. The real one actually works. Wish I'd just bought Chime from the start.",
  likes: 89
}, {
  name: 'Priya S.',
  initial: 'PS',
  timestamp: '5 days ago',
  text: "As someone with GAD, this isn't a replacement for therapy or meds, but it is helpful the moment. I use it before difficult conversations and it genuinely takes the edge off.",
  likes: 156
}, {
  name: 'Chris L.',
  initial: 'CL',
  timestamp: '1 week ago',
  text: "The 30-day guarantee is legit. I was ready to return it but ended up keeping it. It's not magic but it works better than I expected.",
  likes: 73
}, {
  name: 'Maya K.',
  initial: 'MK',
  timestamp: '1 week ago',
  text: 'My therapist actually recommended this article to me. She uses Chime with several clients. That endorsement meant more than any ad could.',
  likes: 201
}, {
  name: 'Jordan P.',
  initial: 'JP',
  timestamp: '2 weeks ago',
  text: "Bought it, tried it for a week, and I'm still using it. The fact that it requires zero setup or app is honestly the best part. It's just... there when you need it.",
  likes: 94
}, {
  name: 'Alex T.',
  initial: 'AT',
  timestamp: '2 weeks ago',
  text: 'I was SO ready to hate this. The price seemed ridiculous. But the author is right — the cheap one does nothing and the expensive one actually works. That calibrated airway is the whole point.',
  likes: 118
}, {
  name: 'Sam D.',
  initial: 'SD',
  timestamp: '3 weeks ago',
  text: 'For anyone on the fence: the money-back guarantee is real. I almost returned mine in week one, gave it another week, and now I wear it daily. Give it the full trial period.',
  likes: 82
}];
export function CommentsSection() {
  return <section className="my-16 bg-gray-50 border border-gray-200 rounded-xl p-8" data-id="element-41">
      <div className="flex items-center gap-2 mb-8" data-id="element-42">
        <MessageCircle size={24} className="text-gray-700" data-id="element-43" />
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-44">
          Comments ({comments.length})
        </h2>
      </div>

      <div className="space-y-6" data-id="element-45">
        {comments.map((comment, index) => <CommentCard key={index} {...comment} index={index} data-id="element-46" />)}
      </div>
    </section>;
}